import { render, staticRenderFns } from "./PaymentRequests.vue?vue&type=template&id=01703092&"
import script from "./PaymentRequests.vue?vue&type=script&lang=js&"
export * from "./PaymentRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports